module.exports = __webpack_public_path__ + "img/iso6336-5-2003_fig07.79e14ea3.png";